// extracted by mini-css-extract-plugin
module.exports = {"messagesContainer":"ConversationPane_messagesContainer__2-Jd0"};